import Vue from 'vue';

export default {
  checkOnBeforeUpload (file, nameArr, size) {
    // file要检验的文件
    // nameArr 符合规范的名称
    // size 文件大小 < 最大值
    const name = file.name.substring(file.name.lastIndexOf('.') + 1);
    const fileSize = file.size / size / 1024 / 1024 <= 1;
    if (nameArr.indexOf(name) > -1) {
      if (!fileSize) {
        Vue.prototype.Config.ROOT_VUE.$message.error(Vue.prototype.Config.ROOT_VUE.$t('rules.upLoadLimitError'));
        return false;
      }
      return true;
    } 
    Vue.prototype.Config.ROOT_VUE.$message.error(Vue.prototype.Config.ROOT_VUE.$t('rules.upLoadTypeError'));
    return false;
  },
  // 工单中可输入多个 机柜编码/设备编码/SN号 搜索，用空格分开
  searchRegularConversion(value) {
    let newValue = value.trim().replace(/，/gi, ',');
    newValue = newValue.replace(/\s+/g, ',');
    newValue = newValue.replace(/,+/g, ',');
    newValue = newValue.replace(/^,+/g, '');
    newValue = newValue.replace(/,+$/g, '');
    return newValue;
  },
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0; const
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
};



// WEBPACK FOOTER //
// ./src/lib/popHelper.js